import React from "react";
import {
  Modal,
  View,
  TouchableOpacity,
  TouchableWithoutFeedback,
} from "react-native";
import StyledText from "../../common/ui/styled-text";
import { Clock, Power, X } from "lucide-react-native";

const PauseModal = ({
  visible,
  onSelectDuration,
  onClose,
}: {
  visible: boolean;
  onSelectDuration: (duration: number) => void;
  onClose: () => void;
}) => {
  const durations = [
    {
      label: "1 hour",
      value: 1,
      icon: <Clock size={16} color="#6b7280" />,
    },
    {
      label: "4 hours",
      value: 4,
      icon: <Clock size={16} color="#6b7280" />,
    },
    {
      label: "8 hours",
      value: 8,
      icon: <Clock size={16} color="#6b7280" />,
    },
    {
      label: "24 hours",
      value: 24,
      icon: <Clock size={16} color="#6b7280" />,
    },
  ];

  const handleSelect = (duration: number) => {
    onSelectDuration(duration);
    onClose();
  };

  return (
    <Modal
      visible={visible}
      transparent={true}
      animationType="none"
      onRequestClose={onClose}
      onDismiss={onClose}
    >
      <TouchableWithoutFeedback onPress={onClose}>
        <View className="flex-1 bg-black/50 justify-center items-center">
          <TouchableWithoutFeedback onPress={(e) => e.stopPropagation()}>
            <View className="bg-white rounded-xl p-5 w-4/5 max-w-[400px] z-50">
              <TouchableOpacity
                className="absolute top-2 right-2 cursor-pointer z-50 p-2"
                onPress={onClose}
              >
                <X size={20} color="#6b7280" />
              </TouchableOpacity>
              <StyledText className="text-lg font-bold text-center mb-1 z-40">
                Pause or Disable
              </StyledText>
              <StyledText className="text-sm text-center text-gray-500 mb-4">
                Your AI assistant will be temporarily paused and resume
                automatically after the selected duration.
              </StyledText>

              {durations.map((duration, index) => (
                <TouchableOpacity
                  key={index}
                  className={`py-3 hover:bg-gray-100 my-1 border border-gray-200 rounded-lg`}
                  onPress={() => handleSelect(duration.value)}
                >
                  <View className="flex-row items-center gap-2 px-2">
                    {duration.icon}
                    <StyledText className="text-base text-left text-gray-800">
                      {duration.label}
                    </StyledText>
                  </View>
                </TouchableOpacity>
              ))}

              <View className="mt-4 border-t border-gray-200 pt-4">
                <TouchableOpacity
                  className="py-3 bg-red-100 hover:bg-red-200 rounded-lg border border-red-200"
                  onPress={() => handleSelect(Infinity)}
                >
                  <View className="flex-row items-center justify-center gap-2 px-2">
                    <Power size={16} color="#b91c1c" />
                    <StyledText className="text-base text-center text-red-700">
                      Indefinitely
                    </StyledText>
                  </View>
                </TouchableOpacity>
              </View>
            </View>
          </TouchableWithoutFeedback>
        </View>
      </TouchableWithoutFeedback>
    </Modal>
  );
};

export default PauseModal;
